import React from 'react';
import { Handle, Position } from 'reactflow';
import { ZapOff } from 'lucide-react'; // Using the 'ZapOff' icon

const LoopBreakNode = ({ data }) => {
    const statusStyles = {
        idle: "border-rose-500",
        pending: "border-yellow-400",
        queued: "border-blue-400",
        failed: "border-red-500",
        success: "border-green-500",
        running: "animate-[pulse_1s_infinite] border-green-500",
        approvalNeeded: "animate-[glow_1.5s_infinite] border-orange-500",
        diagnosing: "animate-[pulse_1s_infinite] border-purple-500", // 👈 new line
    };

    // Default to 'idle' if status is not provided or invalid
    const status = data?.status || "idle";
    const isLoading = status === "running" || status === "pending" || status === "diagnosing";

    return (
        <div className={`w-48 bg-zinc-900 border-2 rounded-xl shadow-lg ${statusStyles[status]}`}>
            <div className="p-3 flex items-center justify-center gap-3">
                <ZapOff className="text-rose-400" size={20} />
                <h3 className="font-bold text-lg text-white">Loop Break</h3>
            </div>
            {/* Handles for connections */}
            <Handle 
                type="source" 
                position={Position.Right} 
                className="w-3 h-3 !bg-teal-500" 
            />
            <Handle 
                type="target" 
                position={Position.Left} 
                className="w-3 h-3 !bg-rose-500" 
            />
        </div>
    );
};

export default LoopBreakNode;